import moment from 'moment';

class CreateSubcontractorModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CreateCustomerModal';
    $scope.customerName = '';
    $scope.customerShortName = '';

    let self = this;
    $scope.addCustomer = function () {
      $uibModalInstance.success($scope.customerName.trim(), $scope.customerShortName.toUpperCase().trim());
    }

  }
}

export default CreateSubcontractorModalController;



// WEBPACK FOOTER //
// ./client/common/modals/createSubcontractorModal/createSubcontractorModal.controller.js